// 顔画像の最大登録枚数
export const MAX_FACE_IMAGES = 3

// 顔画像スロットの初期値 [{ file: File|null, previewImg: string }, ...]
export const createEmptyImages = () => {
  return Array.from({ length: MAX_FACE_IMAGES }, () => ({ file: null, previewImg: '' }))
}
